export default __webpack_public_path__ + "static/media/pic_end_chat_now.56150c68.png";